// extracted by mini-css-extract-plugin
export default {"grid":"order-submit-page_grid__4OM1i","left":"order-submit-page_left__47YpV","actions":"order-submit-page_actions__0NGcP"};